import { useContent } from "@/hooks/useContent";
import { useUserState, useToggleAction } from "@/hooks/useUserData";
import { ActionItem } from "@/components/ActionItem";
import { PillarIcon } from "@/components/PillarIcon";

export function Percorso() {
  const { data: content } = useContent();
  const { data: state } = useUserState();
  const toggle = useToggleAction();

  if (!content) return <div className="flex justify-center pt-20"><div className="w-9 h-9 rounded-full border-4 border-[#6B2247] border-t-[#E32C8C] animate-spin" /></div>;

  const actions = state?.actions || {};
  const total = content.pillar_order.reduce(
    (n, p) => n + content.pillars[p].actions.reduce((a, _, i) => a + (actions[`${p}-${i}`] ? 1 : 0), 0),
    0
  );

  return (
    <div className="bw-fade">
      <div className="mb-5">
        <p className="text-xs uppercase tracking-widest text-[#EAC6D9] font-semibold">Il tuo percorso</p>
        <h1 className="font-serif text-4xl font-bold text-[#F6DCEA]">20 gesti d'amore</h1>
      </div>

      <div className="rounded-2xl bg-[#2A0A1B] border border-[#E32C8C]/35 bw-card p-5 mb-5" data-testid="percorso-progress">
        <div className="flex justify-between items-end mb-2">
          <span className="text-sm font-semibold text-[#EAC6D9]">Avanzamento totale</span>
          <span className="font-serif text-3xl font-bold text-[#E32C8C]">{total}<span className="text-lg text-[#EAC6D9]">/20</span></span>
        </div>
        <div className="h-2.5 rounded-full bg-[#6B2247] overflow-hidden">
          <div className="h-full bg-gradient-to-r from-[#E32C8C] to-[#8E1A52] rounded-full transition-all duration-500" style={{ width: `${(total / 20) * 100}%` }} />
        </div>
      </div>

      <div className="space-y-5">
        {content.pillar_order.map((p) => {
          const meta = content.pillars[p];
          return (
            <div key={p} className="rounded-2xl bg-[#2A0A1B] border border-[#E32C8C]/35 bw-card p-5" data-testid={`percorso-pillar-${p}`}>
              <div className="flex items-center gap-2 mb-3">
                <span className="w-8 h-8 rounded-full flex items-center justify-center" style={{ backgroundColor: `${meta.color}1A` }}>
                  <PillarIcon pillar={p} className="w-4 h-4" style={{ color: meta.color }} />
                </span>
                <div>
                  <h2 className="font-serif text-2xl font-semibold text-[#F6DCEA] leading-none">{meta.name}</h2>
                  <p className="text-xs text-[#EAC6D9]">{meta.subtitle}</p>
                </div>
              </div>
              <div className="space-y-2">
                {meta.actions.map((label, i) => {
                  const id = `${p}-${i}`;
                  return (
                    <ActionItem
                      key={id} label={label} checked={!!actions[id]}
                      onToggle={() => toggle.mutate({ action_id: id, done: !actions[id] })}
                      testId={`percorso-action-${p}-${i}`} color={meta.color}
                    />
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
